module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-t-20 m-b-20"
  }, _vm._l((_vm.lessons), function(objLesson) {
    return _c('article', {
      staticClass: "message is-black"
    }, [_c('div', {
      staticClass: "message-header"
    }, [_c('h1', [_vm._v(_vm._s(objLesson.header))])]), _vm._v(" "), _c('div', {
      staticClass: "message-body"
    }, _vm._l((objLesson.body), function(body) {
      return _c('p', {
        staticStyle: {
          "margin-bottom": "10px"
        },
        domProps: {
          "innerHTML": _vm._s(body)
        }
      })
    }), 0)])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f91e918","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Lessons.vue
// module id = 510
// module chunks = 1